import React from 'react';
import { workProcess } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const ProcessCard = ({ step, index }) => {
  const anim = useScrollAnimation({ threshold: 0.2 });
  return (
    <div
      ref={anim.ref}
      data-testid={`process-step-${step.id}`}
      className={`group icon-shift relative rounded-xl p-8 bg-[#0A0A12] border border-white/[0.06] card-hover-premium card-glow-border text-center scroll-fade-up scroll-delay-${index + 1} ${anim.isVisible ? 'scroll-visible' : ''}`}
    >
      <div className="icon-container w-14 h-14 rounded-lg bg-white/5 flex items-center justify-center mx-auto mb-5 transition-colors">
        <span className="text-xl font-black text-indigo-400 transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>{step.step}</span>
      </div>
      <h3 className="text-lg font-bold text-white mb-3 group-hover:text-amber-400 transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>
        {step.title}
      </h3>
      <p className="text-sm text-slate-400 leading-relaxed">{step.description}</p>
    </div>
  );
};

const HowWeWorkSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-[#030308] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-20 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-amber-500 mb-3 block font-bold">How It Works</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-white mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Three Steps.<br /><span className="text-gradient-primary">That's It.</span>
          </h2>
          <p className="text-base text-slate-300 leading-relaxed">
            No complicated processes. No months of confusion. We handle everything so you can focus on building your business.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto relative">
          <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent hidden md:block" />
          {workProcess.map((step, index) => (
            <ProcessCard key={step.id} step={step} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
